<template>
  <f7-page>
    <f7-navbar back-link="back">
      <f7-nav-title>
        <navbar-center v-if="currentMenu" :href="`/stores/${this.storeId}/menu-drafts/${currentMenu.variation}/settings`">
          <div slot="title">{{ currentMenu.title }}</div>
          <div slot="subtitle">{{ currentMenu.variation }}</div>
        </navbar-center>
      </f7-nav-title>
    </f7-navbar>

    <f7-progressbar v-if="!currentMenu" infinite color="green"></f7-progressbar>
    <div v-else style="position: absolute; top: 56px; bottom: 0px; width: 100%;">
      <tabs :objects="sortedCategoryObjects">
        <template slot="tabbar-objects" slot-scope="props">
          <template v-if="props.object.type !== 'static'">{{ props.object.title }}</template>
        </template>
        <template slot="tab-objects" slot-scope="props">
          <div
            v-if="props.object.type !== 'static'"
            style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; overflow: auto;">
            <f7-list
              v-for="(group, groupIndex) in props.object.groups.map(id => currentMenu.groups[id])"
              :key="`menu-group${group.id}-${groupIndex}`"
              media-list
              no-hairlines-between
              style="margin: 0px 0px 0px 0px;">
              <div style="height: 48px; line-height: 48px; background-color: rgb(244, 244, 244); color: rgba(0, 0, 0, 0.54); padding: 0px 16px; font-size: 16px; display: flex;">
                <span style="flex: 1 1 auto;">
                  {{ group.title || '次類別' }}
                </span>
              </div>
              <f7-list-item
                v-for="(item, index) in group.items.map(id => currentMenu.items[id])"
                :key="`edit-main-list-group-${index}`"
                :title="`${item.title} ${item.soldOut ? '(已售完)' : ''}`"
                :subtitle="item.abbreviation"
                :text="`NT\$${parseFloat(item.price)}`"
                :style="{ backgroundColor: item.soldOut ? 'rgba(100, 100, 100, 0.5)' : '#FFFFFF' }"
                @click="() => { toggleItem(item) }"
                media-item>
                <img
                  v-if="item.coverImgUrl"
                  :src="ImageUrlBuilder.url64(item.coverImgUrl, storeId)"
                  :srcset="`${ImageUrlBuilder.url128(item.coverImgUrl, storeId)} 2x, ${ImageUrlBuilder.url192(item.coverImgUrl, storeId)} 3x`"
                  style="width: 64px"
                  slot="media">
                <img v-else slot="media" src="@/assets/itemDefault.jpg" alt="預設圖片" style="width: 64px;" />
              </f7-list-item>
            </f7-list>
          </div>
        </template>
      </tabs>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import NavbarCenter from '@/common/components/NavbarCenter'
import Tabs from '@/common/components/Tabs'
import { storeClient } from '@/service/apiClients'

export default {
  dependencies: [
    'platformUtils',
    'ImageUrlBuilder',
    'apiStateType'
  ],
  data () {
    return {
    }
  },
  async created () {
    if (!this.storeId) {
      await this.setStore(this.storeIdProp)
    }
    this.downloadMenu({ version: this.menuVersionProp, variation: this.menuVariationProp, overwrite: true })
  },
  computed: {
    ...mapState('menuModule', ['menus', 'latestVersions']),
    ...mapGetters(['storeId']),
    currentMenu () {
      return this.menus && this.menus[this.menuVariationProp] && this.menus[this.menuVariationProp][this.menuVersionProp]
    },
    sortedCategoryObjects () {
      return Object.keys(this.currentMenu.categories || {})
        .map(k => (this.currentMenu.categories || {})[k])
        .sort((a, b) => a.categoryOrder - b.categoryOrder)
    }
  },
  props: {
    storeIdProp: String,
    menuVariationProp: String,
    menuVersionProp: String
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('menuModule', ['downloadMenu']),
    toggleItem (item) {
      if (item.soldOut) {
        this.cancelItemSoldOut(item.id)
      } else {
        this.setItemSoldOut(item.id)
      }
    },
    async setItemSoldOut (itemId) {
      await storeClient.post(`/stores/${this.storeIdProp}/menus/variations/${this.menuVariationProp}/versions/${this.menuVersionProp}/items/${itemId}/soldOut`)
      this.downloadMenu({ version: this.menuVersionProp, variation: this.menuVariationProp, overwrite: true })
    },
    async cancelItemSoldOut (itemId) {
      await storeClient.delete(`/stores/${this.storeIdProp}/menus/variations/${this.menuVariationProp}/versions/${this.menuVersionProp}/items/${itemId}/soldOut`)
      this.downloadMenu({ version: this.menuVersionProp, variation: this.menuVariationProp, overwrite: true })
    }
  },
  components: {
    Tabs,
    NavbarCenter
  }
}
</script>
